import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/sender',
    name: 'sender',
    // route level code-splitting
    // this generates a separate chunk (sender.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "sender" */ '../views/sender.vue')
  },
  {
    path: '/timer',
    name: 'timer',
    // route level code-splitting
    // this generates a separate chunk (sender.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timer" */ '../views/timer.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
